export enum BfxFindFilterOperatorSet {
  Equal,
  EqualNotEqual,
  InNotIn,
  All,
  // OMS-34517 4.7.x temporary restriction on client id/name, account id/name and client trader
  In,
}
